import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why I don't have a 5 year plan",
  "description": "",
  "published": "2014-01-31T00:00:00.000Z",
  "redirect_from": ["/blog/why-i-dont-have-a-5-year-plan/swizec/6508"],
  "categories": "Local optimum, Mathematical optimization, Optimization problem, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`<`}{`insert irrelevant inspirational image>`}</p>
    <p>{`Somebody once said about me `}<em parentName="p">{`"With Swizec everything is a carefully planned coincidence."`}</em></p>
    <p>{`They were right.`}</p>
    <p>{`Every now and then somebody will ask me whether I've got a 5-year plan. Five year plans are a bit like towels, always having one isn't so much useful as it is a signal of responsibility and being a stand up guy. You're always supposed to have a 5-year plan!`}</p>
    <p>{`But I don't. Never have. Never will.`}</p>
    <p>{`This surprises people. It's not the answer they expect from an obviously career-driven 26 year old megalomaniac who wears button up shirts and shoes that go klak when you walk. Almost as surprising as never having voted in my life.`}</p>
    <p>{`You see, people ask about your 5-year plan out of two reasons:`}</p>
    <ul>
      <li parentName="ul">{`assessing what you want from life when considering long-term business deals`}</li>
      <li parentName="ul">{`building familiarity by asking about what you want from life`}</li>
    </ul>
    <p>{`When you say `}<em parentName="p">{`"Yeah I don't really have a plan. They're either too realistic and undershoot what actually happens, or they are dreams and you're left disappointed by reality."`}</em></p>
    <p>{`And that's the gist of the problem. Plans are either dreams - `}<em parentName="p">{`"I am most def selling 10,000 copies of my book this year! I can just see the troves of adoring fans!"`}</em>{`, or it's too restrictive and limits you to a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Local_optimum",
        "title": "Local optimum"
      }}>{`local optimum`}</a>{` - `}<em parentName="p">{`"I have to focus now, no time for that party where all the biggest tech people in my city are going to be that I've been invited to."`}</em></p>
    <p>{`I've done both. It's stupid.`}</p>
    <p>{`Life is actually just a multivariate `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Search_problem",
        "title": "Search problem"
      }}>{`search problem`}</a>{`. Except you don't know what you're looking for.`}</p>
    <p>{`Rather than a plan, I have a search function. My life is a space of possibilities and at key moments, the search function decides where I'm going.`}</p>
    <p>{`All I have to do is decide the optimisation parameters. Do I want more money, more reach, more fame and recognition, punch out cool code, or write a book? Maybe just meet more people and make friends?`}</p>
    <p>{`Whatever it is, I plug it into the function and voila. Life starts turning in that direction. I get more business deals, or I write more blogpost, or just make a bunch of new friends and expand my social circle.`}</p>
    <p>{`The important part is, I don't have to know where I am going. Life makes sure I eventually get exactly what I want. It's really neat.`}</p>
    <p>{`For a simple example, you can think of it as finding the tallest peak in a mountain range. Your optimisation parameter is having the highest possible Z. So generally speaking you should be walking uphill.`}</p>
    <p>{`Eventually you reach a peak and every next step you make is going to be downhill. So you look around, you reassess, and out there in the distance, you see a taller hill.`}</p>
    <p>{`Now your optimisation parameters are reducing Z, and aiming X and Y generally in the direction of that hill.`}</p>
    <p>{`Every step you make, you look at your function and take the best possible step. Day to day, you never have to know where you're going. But eventually you will come up to that peak and it's going to be awesome and you will be really happy.`}</p>
    <p>{`Then you reassess. And what's that if not another even taller hill?`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=6e372d7f-5b24-4e1a-a5de-28df068663ba",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      